import React, { Component } from "react";
import moment from "moment";
import ScGridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
import monthPickerHoc from "@/hoc/form/monthPickerHoc";
import { getUpgrade } from "@/fetch/fetchApi";

const defaultDate = moment();

@monthPickerHoc
class stubFrameWorkList extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    
    this.state = {
      gridData: [],
      exportMes: "导出",
    };
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
    this.query = {
      month: defaultDate.format("YYYY-MM"),
      stubId: this.props.stubId,
      page: 1,
    };
  }

    static contextTypes = {
      store: PropTypes.object.isRequired,
    }

    componentWillMount() {
      this.init();
    }

    init() {
      console.log(this.query);
      this.setState({
        tableConfig: {
          tableColumns: [{
            name: "执行时间",
            key: "otaEndTime",
            colType: "textCol",
            align: "center",
          },
          //  {
          //     name: '固件型号',
          //     key: 'versionType',
          //     colType: 'textCol',
          //     align: 'center',
          // },
          {
            name: "升级前版本",
            key: "versionPre",
            colType: "textCol",
            align: "center",
          }, {
            name: "升级后版本",
            key: "versionAfter",
            colType: "textCol",
            align: "center",
          }, {
            name: "执行结果",
            key: "status",
            colType: "textCol",
            align: "center",
            render: (value, row) => {
              if (value === 0) {
                return (<div>进行中</div>);
              } else if (value === 1) {
                return (<div>升级成功</div>);
              } else if (value === 2) {
                return (<div>{row.errorMsg}</div>);
              } else {
                return (<div>--</div>);
              }
            },
          },
          // {
          //     name: '备注',
          //     key: 'status',
          //     colType: 'textCol',
          //     align: 'center',
          //     render:(value,row,index)=>{
          //         if(value == 0 || value == 1){
          //             return (<div>--</div>)
          //         }else if(value == 2){
          //             return (<div>升级失败</div>)
          //         }else{
          //             return (<div>--</div>)
          //         }
          //     }
          // },
          {
            name: "执行人",
            key: "userName",
            colType: "textCol",
            align: "center",
          }],
          tableParam: {
            pageCount: 10,
            stubId: this.props.stubId,
          },
          tableInfo: {
            hasRow: !1, // 是否显示checkbox
          },
          tableChange: () => {
            // grid翻页页，排序， 筛选过滤时触发
            console.debug("change");
          },
          autoRefresh: 1, // 设置为true 直接加载grid数据
          dataApi: getUpgrade,
          tableKey: "statusLog",
        },
      });
    }

    fetchApi = (params) => {
      let result = {
        ...params,
      };
      if (params.month) {
        result = {
          ...result,
          month: params.month.format("YYYYMM"),
        };
      }
      return result;
    };

    render() {
      return (
        <div className="sc-page-content">
          <div className="page-panel">
            <ScGridTable config={this.state.tableConfig} />
          </div>
        </div>
      );
    }
}

export default stubFrameWorkList;



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/stubFrameWorkList.js